/**
 * Stable CSS class names for E2E — Return / Add bank account drawer content.
 */
export const RCADC = {
    root: 'return-card-add-drawer-content',
    outer: 'return-card-add-drawer-content__outer',
    inner: 'return-card-add-drawer-content__inner',
    form: 'return-card-add-drawer-content__form',
    container: 'return-card-add-drawer-content__container',
    fieldsLayout: 'return-card-add-drawer-content__fields-layout',

    fieldGridItem: 'return-card-add-drawer-content__field-grid-item',
    fieldWrap: 'return-card-add-drawer-content__field',
    fieldAutocompleteWrap: 'return-card-add-drawer-content__field-autocomplete-wrap',
    fieldHelperText: 'return-card-add-drawer-content__field-helper-text',
    fieldText: 'return-card-add-drawer-content__field-text',

    submitRow: 'return-card-add-drawer-content__submit-row',
    submitButton: 'return-card-add-drawer-content-input--button-submit',
} as const;

export const rcadcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

